const LoseMPEvent = function( battleState, potency ) {
	this.eventHandle = 'lose_mp';
	this.potency = potency;	

	this.execute = ( victim ) => {
		this.victimId = victim.uid;

		victim.mp -= potency;

		this.affectedPieces = [ victim ]; 
		battleState.onBattleEvent( this );	
	};
};
module.exports = LoseMPEvent
